/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vapor pressure at temperature`)
};

const es_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presión de vapor a temperatura`)
};

const de_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dampfdruck bei Temperatur`)
};

const nl_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dampspanning bij temperatuur`)
};

const fr_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pression de vapeur à température donnée`)
};

const it_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tensione di vapore alla temperatura`)
};

const pt_br2_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão de vapor por temperatura`)
};

const pt_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão de vapor à temperatura`)
};

const ja_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`温度から蒸気圧を求める`)
};

const zh_bp_mode_vp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指定温度下的蒸气压`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_mode_vp = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_mode_vp(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_mode_vp", locale)
	if (locale === "en") return en_bp_mode_vp(inputs)
	if (locale === "es") return es_bp_mode_vp(inputs)
	if (locale === "de") return de_bp_mode_vp(inputs)
	if (locale === "nl") return nl_bp_mode_vp(inputs)
	if (locale === "fr") return fr_bp_mode_vp(inputs)
	if (locale === "it") return it_bp_mode_vp(inputs)
	if (locale === "pt-BR") return pt_br2_bp_mode_vp(inputs)
	if (locale === "pt") return pt_bp_mode_vp(inputs)
	if (locale === "ja") return ja_bp_mode_vp(inputs)
	return zh_bp_mode_vp(inputs)
};